import { selectChainsSearchTopVenues } from '../chains-report-search-selectors-factory';
import { createSelector } from '@reduxjs/toolkit';

export const selectSearchSelectedVenuesCount = createSelector(
    selectChainsSearchTopVenues,
    (topVenues) => topVenues?.venues.length,
);
